import { createSelector } from 'reselect'

import { selectPlanningWizardState } from './selectPlanningWizardState'

export const selectWizardWasOpened = createSelector(
  [selectPlanningWizardState],
  (planningWizard) => planningWizard.wasOpened
)
